var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.9974L6 7.9974M14 11.9974L6 11.9974M14 3.99739L6 3.9974M3.33333 7.9974C3.33333 7.62921 3.03486 7.33073 2.66667 7.33073C2.29848 7.33073 2 7.62921 2 7.9974C2 8.36559 2.29848 8.66406 2.66667 8.66406C3.03486 8.66406 3.33333 8.36559 3.33333 7.9974ZM3.33333 11.9974C3.33333 11.6292 3.03486 11.3307 2.66667 11.3307C2.29848 11.3307 2 11.6292 2 11.9974C2 12.3656 2.29848 12.6641 2.66667 12.6641C3.03486 12.6641 3.33333 12.3656 3.33333 11.9974ZM3.33333 3.9974C3.33333 3.62921 3.03486 3.33073 2.66667 3.33073C2.29848 3.33073 2 3.62921 2 3.9974C2 4.36559 2.29848 4.66406 2.66667 4.66406C3.03486 4.66406 3.33333 4.36559 3.33333 3.9974Z",
    stroke: "#D0D0D0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.6b9b9cdff818f5f23a774b1d5d3eb392.svg";
export { ForwardRef as ReactComponent };